import React, { useCallback } from 'react';
import { Box, Chip } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { useField } from 'formik';
import { useProviderLicensesStatusQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';
import { ConditionalWrapper } from '../../../../Utils';
import { Tooltip } from '../../../../Tooltip';

export type ExistingOrInviteToggleProps = {
  name: string;
  onChange: (value: boolean) => void;
};

export const ExistingOrInviteToggle: React.FC<ExistingOrInviteToggleProps> = ({ name, onChange }) => {
  const me = useCurrentuser();
  const l10n = useL10n();
  const [ field, _meta, helpers ] = useField<boolean>(name);
  const isNew = field.value;
  const { data = [] } = useProviderLicensesStatusQuery(me.id);
  const disabled = !data?.length;

  const handleChange = useCallback((value: boolean) => {
    onChange(value);

    helpers.setValue(value);
  }, [ helpers, onChange ]);

  return (
    <Box display="flex" gap="8px">
      <Chip
        label={l10n.schedule.createAppointment.scheduleExistingPatient}
        color={isNew ? 'default' : 'secondary'}
        variant={isNew ? 'outlined' : 'filled'}
        onClick={() => handleChange(false)}
      />
      <ConditionalWrapper
        condition={disabled}
        wrapper={children => (
          <Tooltip title={`You don't have a license added to your profile to do this action, please contact support ${l10n.helpEmail}`} placement="bottom">
            <span>
              {children}
            </span>
          </Tooltip>
        )}
      >
        <Chip
          disabled={disabled}
          label={l10n.schedule.createAppointment.inviteNewPatient}
          color={isNew ? 'secondary' : 'default'}
          variant={isNew ? 'filled' : 'outlined'}
          onClick={() => handleChange(true)}
        />
      </ConditionalWrapper>
    </Box>
  );
};
